/* istanbul ignore file */
import React from 'react';
import PassportNumberLayout from 'domain/people/employee/shared/layout/PassportNumberLayout';
import { DefaultInputPropTypes, TextInput } from 'framework/form';

interface PassportNumberInputProps extends DefaultInputPropTypes<string> {
  isOnlyNumber: boolean;
}

const PassportNumberInput = ({ source, isOnlyNumber, ...props }: PassportNumberInputProps) => {
  const passportNumberInput = <TextInput {...props} source={`${source}.number`} />;

  const passportSeriesInput = <TextInput {...props} source={`${source}.documentDetails.series`} />;

  return isOnlyNumber ? (
    passportNumberInput
  ) : (
    <PassportNumberLayout passportNumberInput={passportNumberInput} passportSeriesInput={passportSeriesInput} />
  );
};

export default PassportNumberInput;
